import { BusinessCustomerTypesEnum } from '../../../CustomerDataPage/customerDataPage.model';
import { MockSearchCustomerFormModel } from './formModel';

export const getInitialValues = (): MockSearchCustomerFormModel => {
  return {
    businessCustomerType: BusinessCustomerTypesEnum.ltd,
    legalName: undefined,
    email: undefined,
    countryCode: undefined,
    mobileNumber: undefined,
  };
};
